<template>
	<div class="comp">
		<div class="L">
			<div style="line-height: 36px;text-align: center; color: #343440;font-size: 14px;font-weight: bold; cursor: pointer; margin-bottom: 10px;background-color: #F6F8FF;border-radius: 8px;" @click="open_changePetInfo('')">
				新增宠物
			</div>
			<div class="LItem" :class="curPet._id===item._id?'active':''" v-for="(item,index) in petList" :key="index" @click="changeCurPet(item)">
				<div class="navL">
					<img v-if="item.apply_type&&item.apply_type.value==='1'" class="petAtavar" src="../../../../assets/img/member/cat.png"/>
					<img v-else-if="item.apply_type&&item.apply_type.value==='2'" class="petAtavar" src="../../../../assets/img/member/dog.png"/>
					<img v-else class="petAtavar" src="../../../../assets/img/index/headPic.jpg"/>
					
					<img v-if="item.hs_pet===true" class="petLevel" src="../../../../assets/img/member/vip_pet.png"/>
				</div>
				<div class="navR">
					<div class="petName">{{item.nick_name}}</div>
					<div class="petMsg">
						{{item.weight||0}}kg | 
						{{$public.FAge(item.bron_date)[0]}}岁{{$public.FAge(item.bron_date)[1]}}月 | 
						{{item.category_info.name}} | 
						{{item.pet_sex}} | 
						{{item.sterilization===1?'已绝育':'未绝育'}}
					</div>
					<div class="petNum">芯片号：{{item.eprom_no}}</div>
					<div class="petBtn">
						<i class="el-icon-edit-outline" style="font-size: 20px;" @click.stop="open_changePetInfo(item)"></i>
						<i class="el-icon-view" slot="reference" style="font-size: 20px;margin-left: 10px;color:#577BFF;" @click="drawerPetInfo=item;compCustomRecord_state=true"></i>
						<!-- <img class="petIcon" src="../../../../assets/img/index/headPic.jpg" /> -->
					</div>
				</div>
			</div>
		</div>
		<div class="R">
			<div class="panel">
				<div class="petDetail">
					<div class="petDetailItem">
						体重：{{curPet.weight}}kg
					</div>
					<div class="petDetailItem">
						品种：{{curPet.category_info&&curPet.category_info.name}} 
					</div>
					<div class="petDetailItem">
						性别：{{curPet.pet_sex}} 
					</div>
					<div class="petDetailItem">
						毛色：{{curPet.pet_color}} 
					</div>
					<div class="petDetailItem">
						出生日期：{{curPet.bron_date}}
					</div>
					<div class="petDetailItem">
						年龄：{{$public.FAge(curPet.bron_date)[0]}}岁{{$public.FAge(curPet.bron_date)[1]}}月 
					</div>
					<div class="petDetailItem">
						状态：{{curPet.status&&curPet.status.title}}
					</div>
				</div>
				<div class="searchLine">
					<div class="searchLineL">
						<div class="searchItem" :class="curTab0NavIndex===0?'active':''" @click="changeCurTab0NavIndex(0)">
							<span>病例记录</span>
							<span v-if="curTab0NavIndex===0" class="searchItemActiveBar"></span>
						</div>
						<div class="searchItem" :class="curTab0NavIndex===1?'active':''" @click="changeCurTab0NavIndex(1)">
							<span>疫苗驱虫</span>
							<span v-if="curTab0NavIndex===1" class="searchItemActiveBar"></span>
						</div>
						<div class="searchItem" :class="curTab0NavIndex===2?'active':''" @click="changeCurTab0NavIndex(2)">
							<span>医疗服务</span>
							<span v-if="curTab0NavIndex===2" class="searchItemActiveBar"></span>
						</div>
						<div class="searchItem" :class="curTab0NavIndex===3?'active':''" @click="changeCurTab0NavIndex(3)">
							<span>体重记录</span>
							<span v-if="curTab0NavIndex===3" class="searchItemActiveBar"></span>
						</div>
					</div>
					<div class="searchLineR">
						
					</div>
				</div>
				<!-- 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 病例 -->
				<div v-show="curTab0NavIndex===0">
					<div class="list" v-if="$public.isNull(tableData0)" style="background-color: #fff;height: 200px;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData0" >
							<el-table-column prop="no" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="病例单号" prop="caseNumber">
								<template slot-scope="props">
									<span>{{props.row.caseNumber}}</span>
								</template>
							</el-table-column>
							<el-table-column label="医生" prop="doctorName" width="90">
							</el-table-column>
							<el-table-column label="病例日期" width="110">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="状态" width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" width="120">
							</el-table-column>
							<el-table-column label="操作" width="70">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="curItem=props.row;drawerBingliSee_state=true">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page0.page" :total="page0.total" @change="changePage0"></page>
						</div>
					</div>
				</div>
				<!-- 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 疫苗驱虫 -->
				<div v-show="curTab0NavIndex===1">
					<div class="list" v-if="$public.isNull(tableData1)" style="background-color: #fff;height: 200px;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData1" >
							<el-table-column prop="no" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="单号" prop="serviceId" width="110">
							</el-table-column>
							<el-table-column label="类别" width="50">
								<template slot-scope="props">
									<div v-if="props.row.serviceTypeId===1">疫苗</div>
									<div v-if="props.row.serviceTypeId===2">驱虫</div>
								</template>
							</el-table-column>
							<el-table-column label="套餐名称" min-width="120" prop="servicePackageName">
							</el-table-column>
							<el-table-column label="计划名称" width="90" prop="planName">
							</el-table-column>
							<el-table-column label="计划时间" width="100">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.planDate,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="添加人" width="70" prop="createUserName">
							</el-table-column>
							<el-table-column label="状态" width="70">
								<template slot-scope="props">
									<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
									<div style="color:#FD4E4E" v-else>未支付</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="50">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="curItem=props.row;drawerYmqcSee_state=true;">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page1.page" :total="page1.total" @change="changePage1"></page>
						</div>
					</div>
				</div>
				<!-- 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务 医疗服务  -->
				<div v-show="curTab0NavIndex===2">
					<div class="list" v-if="$public.isNull(tableData2)" style="background-color: #fff;height: 200px;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData2" >
							<el-table-column prop="no" label="序号" width="50">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="单号" prop="id" width="120">
							</el-table-column>
							<el-table-column label="套餐名称" prop="medicalServiceName" min-width="150">
							</el-table-column>
							<el-table-column label="年龄" prop="birthDay" width="90">
								<template slot-scope="props">
									<span>{{$public.FAge(new Date(props.row.birthDay).getTime())[0]}}岁</span>
									<span>{{$public.FAge(new Date(props.row.birthDay).getTime())[1]}}月</span>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" width="100">
								<template slot-scope="props">
									<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD')}}</div>
								</template>
							</el-table-column>
							<el-table-column label="支付状态" width="80">
								<template slot-scope="props">
									<div >
										<span style="color:#FD4E4E" v-if="props.row.isPay==0">未支付</span>
										<span style="color:#18A44C" v-if="props.row.isPay==1">已支付</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="备注" prop="remark" width="80">
							</el-table-column>
							<el-table-column label="操作" width="60">
								<template slot-scope="props">
									<el-button type="text" size="mini" @click="curItem=props.row;drawerYlfwSee_state=true">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagePosi">
							<page style="padding:10px 0;" :page="page2.page" :total="page2.total" @change="changePage2"></page>
						</div>
					</div>
				</div>
				<!-- 体重  体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 体重 -->
				<div v-show="curTab0NavIndex===3">
					<div class="list" v-if="$public.isNull(tableData3)" style="background-color: #fff;height: 200px;">
						<div style="padding-top:60px;text-align: center;">暂无数据</div>
					</div>
					<div class="list" v-else>
						<el-table :data="tableData3" >
							<el-table-column prop="no" label="序号" width="80">
								<template slot-scope="scope">
									{{scope.$index+1}}
								</template>
							</el-table-column>
							<el-table-column label="体重(kg)" prop="caseNumber">
								<template slot-scope="props">
									<span>{{props.row.weight}}</span>
								</template>
							</el-table-column>
							<el-table-column label="创建人">
								<template slot-scope="props">
									<div>{{props.row.user_name}}</div>
								</template>
							</el-table-column>
							<el-table-column label="创建时间"  >
								<template slot-scope="props">
									<span>{{$public.FTime(props.row.create_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="备注" >
								<template slot-scope="props">
									{{props.row.weight_reamrk}}
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<div v-if="drawerBingliSee_state===true">
			<drawerBingliSee :curItem="curItem" @submit="drawerBingliSee_state=false"></drawerBingliSee>
		</div>
		<div v-if="drawerYmqcSee_state===true">
			<drawerYmqcSee :curItem="curItem" @submit="drawerYmqcSee_state=false"></drawerYmqcSee>
		</div>
		<div v-if="drawerYlfwSee_state===true">
			<drawerYlfwSee :curItem="curItem" @submit="drawerYlfwSee_state=false"></drawerYlfwSee>
		</div>
		<div v-if="drawerAddEditPetInfo_state===true">
			<drawerAddEditPetInfo :userInfo="userDetail" :petInfo="drawerPetInfo" :dialog_type="$public.isNull(drawerPetInfo)?'addPet':'editPet'" @submit="submit_drawerAddEditPetInfo"></drawerAddEditPetInfo>
		</div>
		<!-- 自定义记录 -->
		<div v-if="compCustomRecord_state">
			<compCustomRecord :linkId="drawerPetInfo._id" :type="customRecordType" @submit="compCustomRecord_state=false"></compCustomRecord>
		</div>
	</div>
</template>

<script>
	import drawerYmqcSee from "@/components/yiliao/drawer_ymqcSee.vue"
	import drawerYlfwSee from "@/components/yiliao/drawer_ylfwSee.vue"
	import drawerBingliSee from "@/components/yiliao/drawer_bingliSee.vue"
	import drawerAddEditPetInfo from "@/components/userPet/drawer_addEditPetInfo.vue"
	import compCustomRecord from "@/components/compCustomRecord.vue"
	import page from "@/components/page.vue"
	export default {
		components:{page,drawerYmqcSee,drawerBingliSee,drawerYlfwSee,drawerAddEditPetInfo,compCustomRecord},
		data() {
			return {
				userDetail:{},
				petList:[],
				curPet:{},
				drawerPetInfo:{},
				drawerAddEditPetInfo_state:false,
				
				curTab0NavIndex:0,
				// 病例
				page0:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData0:[],
				drawerBingliSee_state:false,
				// ymqc
				page1:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData1:[],
				drawerYmqcSee_state:false,
				// ylfw
				page2:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData2:[],
				drawerYlfwSee_state:false,
				// 体重
				// page3:{
				// 	page:1,
				// 	pageSize:10,
				// 	total:0
				// },
				tableData3:[],
				// 自定义记录
				compCustomRecord_state:false,
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getUserDetail();
		},
		methods:{
			changeCurPet(item){
				this.curPet=item;
				if(this.curTab0NavIndex===0){this.getTableData0List()}
				else if(this.curTab0NavIndex===1){this.getTableData1List()}
				else if(this.curTab0NavIndex===2){this.getTableData2List()}
				else if(this.curTab0NavIndex===3){
					this.tableData3 = this.curPet.weight_records||[]
				}
			},
			changeCurTab0NavIndex(i){
				this.curTab0NavIndex=i;
				if(i===0){this.getTableData0List()}
				else if(i===1){this.getTableData1List()}
				else if(i===2){this.getTableData2List()}
				else if(i===3){
					this.tableData3 = this.curPet.weight_records||[]
				}
			},
			getUserDetail(){
				let params = {
					"id": this.$route.query.id,
				}
				this.$http.get(process.env.VUE_APP_member+'/api/middleware/member/single', params).then(res => {
					if (res.code == 0) {
						this.userDetail = res.data;
						this.petList = this.userDetail.pets_info||[]
						if(this.petList.length>0){
							this.curPet = this.petList[0]
							this.getTableData0List()
							this.tableData3 = this.curPet.weight_records||[]
						}
						// this.getUserOrderList(res.data._id);
						// this.getUserOrderRechargeList(res.data._id);
						// this.getUserDiscountList(res.data._id);
						// this.getDeposit(res.data._id)
						// this.getRetrunOrderList(res.data._id)
					}
				})
			},
			// 病例
			changePage0(num){
				this.page0.page=num;
				this.getTableData0List()
			},
			getTableData0List(){
				if(this.$public.isNull(this.curPet._id)) return
				let params = {
					"keyword": '',
					"departmentId": '', 
					"petId": this.curPet._id,
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": this.page0.page,
					"pageSize": this.page0.pageSize,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData0 = res.data.data||[];
						this.page0.total = res.data.count;
					}
				})
			},
			// ymqc
			changePage1(num){
				this.page1.page=num;
				this.getTableData1List()
			},
			getTableData1List(){
				if(this.$public.isNull(this.curPet._id)) return
				let params = {
					"keyword": '',
					"petId": this.curPet._id,
					"serviceTypeId": 0,  // 1疫苗；2驱虫; Default:0 
					"isPay": -1,          // -1 全部；0未支付；1已支付
					"petType": "",       //  猫类；犬类
					"status": 0,         // 1未完成；2已完成
					"enterGoodsState": -1,        // -1 0 1 2
					hasGoods:true,
					"desc": true,
					"shopId":'',
					"pageIndex": this.page1.page,
					"pageSize": this.page1.pageSize,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/MedicalPackage/Plan/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData1 = res.data.data||[];
						this.page1.total = res.data.count;
					}
				})
			},
			// ylfw
			changePage2(num){
				this.page2.page=num;
				this.getTableData2List()
			},
			getTableData2List(){
				if(this.$public.isNull(this.curPet._id)) return
				let params = {
					"payType": 0, // 1全额；2消费卡
					"isPay": -1,  // -1全部；0未支付；1已支付
					serviceStatus:-1,    // -1全部；1待完成；2已完成
					"petType": '',    // 猫类；犬类
					"petId": this.curPet._id,
					"desc": true,
					"pageIndex": this.page2.page,
					"pageSize": this.page2.pageSize
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_business+'/api/MedicalService/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData2 = res.data.data||'';
						this.page2.total = res.data.count;
					}
				})
			},
			// 体重 无
			// 修改宠物信息
			open_changePetInfo(item){
				this.drawerPetInfo=item
				this.drawerAddEditPetInfo_state = true;
			},
			submit_drawerAddEditPetInfo(obj){
				this.drawerAddEditPetInfo_state =false;
				if(obj.type==='success'){
					this.getUserDetail()
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		display: flex;margin-top:16px;height: 100%;
		.L{
			width:372px;background-color: #fff;border-radius: 16px;flex-shrink: 0;padding:24px;box-sizing: border-box;margin-right: 16px;overflow: auto;
			.LItem{
				display: flex;color:$color333;font-size: 14px;cursor: pointer;margin-bottom: 10px;height: 125px;padding:16px;box-sizing: border-box;
				&.active{
					color:#577BFF;background-color: #F6F8FF;
				}
				.navL{
					width:50px;margin-right: 16px;flex-shrink: 0;
					.petAtavar{
						width:50px;height: 50px;border-radius: 50%;
					}
					.petLevel{
						width:30px;padding:10px 10px;
					}
				}
				.navR{
					width:100%;position: relative;
					.petName{
						font-size: 16px;color:$color333;padding:6px 0;
					}
					.petMsg{
						font-size: 14px;color:$color666;padding:10px 0;
					}
					.petNum{
						font-size: 14px;color:$color999;padding:10px 0;
					}
					.petBtn{
						position: absolute;top:0;right:-6px;
						.petIcon{
							width:20px;height: 20px;margin-right: 14px;
						}
					}
				}
			}
		}
		.R{
			width:100%;background-color: #fff;border-radius: 16px;padding:16px 32px;box-sizing: border-box;
			.panel{
				position: relative;height: 100%;
				.petDetail{
					display: flex;flex-wrap: wrap;
					.petDetailItem{
						min-width: 20%;padding:16px 0;font-size: 14px;
					}
				}
				.searchLine{
					display: flex;justify-content: space-between;background-color: #fff;padding:0 0 20px;position: absolute;width:100%;box-sizing: border-box;top:85px;z-index: 1;border-top:1px solid #EBEEF5;margin-top:20px;
					.searchLineL{
						display: flex;padding-top: 16px;
						.searchItem{
							font-size: 14px;color:$color333;margin-right: 40px;cursor: pointer;
							&.active{
								color:#577BFF;
							}
							.searchItemActiveBar{
								display: block;width:18px;height: 4px;background: linear-gradient(135deg, #4BB2FF 0%, #466BFF 100%);border-radius: 3px;margin:8px auto 0;
							}
						}
					}
					.searchLineR{
						
					}
				}
				.list{
					padding-top:62px;border-radius: 16px;overflow: auto;height: calc(100% - 143px);
					.item{
						background-color: #fff;border-radius: 16px;margin-bottom:16px;padding:32px;display: flex;
						.avatarBox{
							.avatar{
								width:56px;height: 56px;border-radius: 50%;margin-right: 16px;
							}
						}
						.avatarBoxR{
							.originalName{
								font-size: 14px;color:$color333;padding-bottom:5px
							}
							.originalTime{
								font-size: 12px;color:$color999;
							}
							.originalTag{
								display: flex;padding-top:10px;
								.tagItem{
									background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
									.tagIcon{
										width:16px;height: 16px;margin-right: 5px;
									}
									.tagText{
										font-size: 12px;color:#4062E7;
									}
								}
							}
							.originalWord{
								padding-top:10px;padding-right: 50px;
								.word{
									font-size: 14px;color:$color333;line-height: 22px;
								}
							}
							.originalImg{
								padding-top:10px;padding-right: 30px;overflow: hidden;white-space: nowrap;width:625px;
								.originalImgItem{
									width:104px;height: 104px;margin-right: 4px;
								}
							}
							.originalBtn{
								display: flex;padding-top:16px;
								.num1{
									font-size: 14px;color:#333;margin-right: 16px;
								}
								.num2{
									font-size: 14px;color:$color999;margin-right: 32px;
								}
								.btn{
									font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
								}
							}
						}
					}
				}
			}
			
		}
		.pagePosi{
			width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
		}
	}
</style>
